export enum TabsComponentTheme {
  blue = 'blue',
  gray = 'gray'
}
